import React from "react"
import badge from "badges/imagining.svg"
import { BadgeImage } from "backpack/badges/styled"

const Imagining = props => <BadgeImage src={badge} {...props} />

export default Imagining
